import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const ResourceTabKind = Schema.Literals([
  "databases", "workflows", "containers", "r2", "kv", "queues", "workers",
  "browser", "flow-recordings", "history", "traces"
]);
export type ResourceTabKind = typeof ResourceTabKind.Type;
export class ResourceTabFocusFailure extends privateDependencyFailure<ResourceTabFocusFailure>()("ResourceTabFocusFailure", "resource tab focus") {}
export const resourceTabFocusFailure = (cause: unknown) => new ResourceTabFocusFailure({ cause: Redacted.make(cause) });
